import { useState } from 'react';
import ChargerModule from 'components/chargerModule';
import { Tabs } from 'components/Tabs/Tabs';
import { IOrderDetailsTabList } from 'types/orders';
import CountriesTab from './countriesTab/CountriesTab';
import CurrenciesTab from './currenciesTab/CurrenciesTab';
import AddCurrencyModalTrigger from './addCurrencyModalTrigger/AddCurrencyModalTrigger';

import './countriesModule.scss';

const COUNTRIES_TAB_ID = 0;
const CURRENCIES_TAB_ID = 1;

/**
 * Vista principal del módulo de países y monedas.
 */
const CountriesModule = () => {
  const [selectedTabId, setSelectedTabId] = useState<number>(COUNTRIES_TAB_ID);

  const headerInfo = {
    title: 'Países',
    subtitle: '',
    headerNote: '*Todos los países creados quedan como opción para gestión de empleados y herramientas.'
  };

  const isCurrenciesTab = selectedTabId === CURRENCIES_TAB_ID;

  const countriesTabsList: IOrderDetailsTabList[] = [
    {
      tabId: COUNTRIES_TAB_ID,
      tabName: 'Países',
      tabComponent: <CountriesTab />
    },
    {
      tabId: CURRENCIES_TAB_ID,
      tabName: 'Monedas',
      tabComponent: <CurrenciesTab />
    }
  ];

  return (
    <ChargerModule headerInfo={headerInfo} infoSideBar={{ position: 'country' }}>
      <div className="countriesModule">
        <div className="countriesModuleTabsHeader">
          <div className="countriesModuleTabsWrapper">
            <Tabs
              tabs={countriesTabsList}
              selectedTabId={selectedTabId}
              defaultSelectedTabId={COUNTRIES_TAB_ID}
              onSelectTab={setSelectedTabId}
            />
          </div>
          {isCurrenciesTab && <AddCurrencyModalTrigger />}
        </div>
        <section className="countriesModuleTabContent">{countriesTabsList[selectedTabId]?.tabComponent}</section>
      </div>
    </ChargerModule>
  );
};

export default CountriesModule;
